import React, { useContext } from 'react'
import { GenericDataContext, GenericDataContextPayload } from '../../context/genericDataContext'
import { Breadcrumbs, Link, useMediaQuery } from '@mui/material' 
import globalStyles from "../../assets/styles/global.module.scss";
import styles from "../../assets/styles/componentStyles/header.module.scss";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ChatbotContext, ChatbotContextPayload } from '../../context/chatbotContext';
import { IntegrationContext, IntegrationContextPayload } from '../../context/integrationContext';
import { breadCrumbObj, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../models/axiosModel';
import { breadCrumbPathName, getWabaName } from '../../utils/constants';

const BreadCrumb = () => {

    const { breadcrumbs, setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload 
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload
    const { integrationListNewStructure } = React.useContext(IntegrationContext) as IntegrationContextPayload
    
    const navigate = useNavigate() 
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')

    const [searchParams, setSearchParams] = useSearchParams()
    const chatbot_id = searchParams.get('chatbot_id')
    const id = searchParams.get('id')

    const pathname = window.location.pathname.toLowerCase();
    
    const handleBreadcrumbClick = (path: string, isActive: boolean, currentIndex: number, isSamePageRedirecting: boolean) => { 
        let updatedBreadcrumb = breadcrumbs;
        if(!isSamePageRedirecting){
            updatedBreadcrumb = breadcrumbs.filter((modules: breadCrumbObj, index: number) => index <= currentIndex);
        }
        if(updatedBreadcrumb.length > 0){
            updatedBreadcrumb[updatedBreadcrumb.length - 1] = {...updatedBreadcrumb[updatedBreadcrumb.length - 1], isActive: true}
        }
        setBreadCrumbs(updatedBreadcrumb); 
        if(!isActive){
            navigate(path)
        }
    }

    return ( 
        <>
            {smallScreen ? 
                <Breadcrumbs className={styles.breadcrumbsStyle}>
                    <Link
                        underline="hover"
                        onClick={() => { chatbot_id ? navigate(`/chatbot`) : navigate(`/channels`) }}
                        className={`${styles.cbHeaderBreadCrumbsHeadText} ${globalStyles.clickable}`}
                    >
                        {chatbot_id ? "AI Chatbot" : "Channels"}
                    </Link>
                    <Link
                        underline="hover"
                        className={`${styles.cbHeaderBreadCrumbsChatbotLabel} ${globalStyles.clickable}`}
                    >
                        {chatbot_id ? chatBotDetails?.chatbot_name : getWabaName(integrationListNewStructure, Number(id), "Facebook Messenger")}
                    </Link>
              </Breadcrumbs>
                :
                !breadCrumbPathName(pathname) &&
                <Breadcrumbs
                    aria-label="breadcrumb"
                    // className={styles.cbHeaderBreadCrumb} 
                    className={globalStyles.globalBreadCrumbs}
                >
                    {breadcrumbs.map((module: breadCrumbObj, index: number) => {
                        return <Link
                                underline="hover" 
                                key={index}
                                onClick={() => { handleBreadcrumbClick(module.path, module.isActive, index, module.isSamePageRedirecting ? module.isSamePageRedirecting : false) }}
                                className={`${module.isActive ? globalStyles.cbHeaderBreadCrumbsChatbotLabel : globalStyles.cbHeaderBreadCrumbsHeadText} ${globalStyles.clickable}`}
                            >
                                {module.name}
                            </Link>
                    })}

                </Breadcrumbs>
            }
        </>
    )
}

export default BreadCrumb
